export default "__VITE_ASSET__DpiBXp0X__"